module.exports = __webpack_public_path__ + "img/full6-min.9d7e7570.png";